import {
  Avatar,
  Box, Flex, Indicator, Stack, Image, rem, Skeleton
} from '@mantine/core';
import { Text, theme } from '@huspy/forge';
import { iconsPath } from '@shared/css.const';
import { ClientDetailsDTO } from '@modules/clients/entities/client/api/dto/clientDetails.dto';
import { useTranslation } from 'react-i18next';
import { clientsDetailsStyle } from './styles/index.css';

const {
  clientDetailsUpperSection, root, avatar, contactIconWrapper,
} = clientsDetailsStyle;

type Props = {
  data?: ClientDetailsDTO;
  isLoading: boolean;
};

const ClientInformationCard = ({
  data: {
    created_at, email, first_name, last_name, stage, mobile,
  } = {} as ClientDetailsDTO, isLoading,
}: Props) => {
  const isProfileCompleted = stage && stage !== 'lead';
  const name = `${first_name} ${last_name}`;
  const initials = `${first_name?.charAt(0) || ''}${last_name?.charAt(0) || ''}`;
  const { t } = useTranslation();

  return (
    <Box w='100%' className={ root }>
      <Stack
        className={ clientDetailsUpperSection }
        gap='md'
        p={ theme.spacing.lg }
        styles={ {
          root: {
            borderBottomLeftRadius: theme.radius.md,
            borderBottomRightRadius: theme.radius.md,
          },
        } }
      >
        <Flex
          justify='flex-start'
          align='center'
          wrap='wrap'
        >
          <Indicator
            inline
            size={ 10 }
            offset={ 7 }
            position='bottom-end'
            color='transperant'
            { ...(isProfileCompleted && { label: <Image src={ `${iconsPath}/check-badge.svg` } /> }) }
          >
            <Avatar
              color='transparent'
              classNames={ { root: avatar } }
              variant='filled'
              size='lg'
              radius='xl'
            >
              <Text size='lg'>
                { initials }
              </Text>
            </Avatar>
          </Indicator>
          <Flex
            mih={ 40 }
            gap='xs'
            justify='flex-start'
            align='flex-start'
            direction='column'
            wrap='wrap'
            ml={ theme.spacing.md }
          >

            {isLoading ? (
              <>
                <Skeleton h={ rem(26) } width={ rem(140) } />
                <Skeleton h={ rem(26) } width={ rem(120) } />
              </>
            ) : (
              <>
                <Text
                  c='neutral.8'
                  fw={ 600 }
                  size='lg'
                  styles={ {
                    root: {
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      width: rem(158),
                      overflow: 'hidden',
                    },
                  } }
                >
                  { name }
                </Text>
                <Text c='neutral.5' size='xs'>
                  { t('clients.createdOn') }
                  {' '}
                  { new Date(created_at).toLocaleDateString('en-GB') }
                </Text>
              </>
            )}
          </Flex>
        </Flex>

        <Flex
          mih={ 20 }
          align='center'
          gap='sm'
          justify='center'
        >
          <Flex
            justify='center'
            align='center'
            className={ contactIconWrapper }
            onClick={ () => {
              window.open(`https://wa.me/${mobile}`, '_blank');
            } }
          >
            <Image
              width={ 12 }
              height={ 12 }
              src={ `${iconsPath}/whatsapp.svg` }
            />
          </Flex>
          <Flex
            justify='center'
            align='center'
            className={ contactIconWrapper }
            onClick={ () => {
              window.open(`mailto:${email}`, '_blank');
            } }
          >
            <Image
              width={ 12 }
              height={ 12 }
              src={ `${iconsPath}/email.svg` }
            />
          </Flex>
        </Flex>
      </Stack>
    </Box>
  );
};

export default ClientInformationCard;
